import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useCycle } from "../../hooks/useCycle";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

const InvitationCarousel = () => {
  const { pendingInvitations, acceptInvitation, declineInvitation } = useAuth();

  const {
    currentItem: invite,
    next,
    prev,
    index,
    total,
    isMultiple,
  } = useCycle(pendingInvitations);

  if (!invite) {
    return null; // Don't render anything if there are no invitations
  }

  return (
    <div className="mb-8 p-6 bg-blue-50 border border-blue-200 rounded-lg shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-blue-800">
          Pending Invitation
        </h2>
        {isMultiple && (
          <span className="text-sm font-medium text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
            {index + 1} of {total}
          </span>
        )}
      </div>
      <div className="relative">
        <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col sm:flex-row justify-between items-center text-center sm:text-left">
          <p className="text-gray-700 mb-3 sm:mb-0 sm:mr-4 flex-grow">
            You've been invited to join{" "}
            <strong>{invite.careProfileName || "Unnamed"}</strong>'s family
            circle
            {invite.relationship ? (
              <>
                {" "}
                as their <strong>{invite.relationship}</strong>
              </>
            ) : null}{" "}
            with <strong>{invite.role}</strong> access.
          </p>
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={() => acceptInvitation(invite)}
              className="flex min-h-11 items-center px-4 py-2 text-sm bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2"
            >
              <FaCheckCircle className="mr-2" /> Accept
            </button>
            <button
              onClick={() => declineInvitation(invite.id)}
              className="flex min-h-11 items-center px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
            >
              <FaTimesCircle className="mr-2" /> Decline
            </button>
          </div>
        </div>

        {isMultiple && (
          <>
            <button
              onClick={prev}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-full p-2 rounded-full bg-white/50 hover:bg-white transition-colors"
              aria-label="Previous invitation"
            >
              <FaChevronLeft className="text-blue-600" />
            </button>
            <button
              onClick={next}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full p-2 rounded-full bg-white/50 hover:bg-white transition-colors"
              aria-label="Next invitation"
            >
              <FaChevronRight className="text-blue-600" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default InvitationCarousel;
